<app-form-wrapper [title]="'no_access.page_bg' | translate">
  <div class="header-xl font font--bold color-primary">{{ 'no_access.text' | translate }}</div>
</app-form-wrapper>
